import { createContext, useContext, useEffect, useState } from "react";
import { CONTENT } from "@/data/spaces";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const saved =
      typeof window !== "undefined" && window.sessionStorage.getItem("lang");
    return saved === "en" || saved === "pl" ? saved : "pl";
  });

  useEffect(() => {
    const t = CONTENT[lang];
    document.documentElement.lang = t.htmlLang;
    document.title = t.title;
    window.sessionStorage.setItem("lang", lang);
  }, [lang]);

  return (
    <LanguageContext.Provider
      value={{ lang, setLang, t: CONTENT[lang], langs: Object.keys(CONTENT) }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);

export default LanguageProvider;
